import type { FieldId } from '~/features/fields/types/FieldId';

import { parseFieldId } from '~/features/fields/isLegacyPilotFieldId';
import { SearchApi } from '~/types/SearchApi';

import { getPromptModelTargetEntities } from './getPromptModelTargetEntities';

export const getPromptModelFieldIds = async ({
  searchApi = 'pilot',
}: { searchApi?: SearchApi } = {}): Promise<FieldId[]> => {
  const items = await getPromptModelTargetEntities({ searchApi });
  const useEvisearch = searchApi === 'evisearch';

  return useEvisearch
    ? items.map((item) => item.target_entity.id)
    : items.map((item) => parseFieldId(item.target_entity.id));
};
